import { useEffect, useState } from "react";
import { LuRouteOff, LuUsers } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import SyncButton from "../../../components/SyncButton/SyncButton";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import FormAntiPassbacks from "../FormAntiPassbacks/FormAntiPassbacks";
import ListAntiPassbacks from "../ListAntiPassbacks/ListAntiPassbacks";
import "./ConsultaAntiPassbacks.css";
import { TbCornerUpRightDouble } from "react-icons/tb";

const ConsultaAntiPassbacks = () => {
	const { lineSelected } = useListManager();
	const [search, setSearch] = useState("");
	const [filters, setFilters] = useState("");
	const { selectedCondominio } = useUserStore();
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<TbCornerUpRightDouble size={20} />}
					title="Anti Passbacks"
					navigate="../cadastro-anti-passbacks"
					buttonLabel="Adicionar Anti Passback"
					aditionalButton1={
						<SyncButton
							type={"antiPassback"}
							selectedCondominio={selectedCondominio}
						/>
					}
				>
					<SearchInput
						value={search}
						placeholder="Buscar Anti Passback"
						onChange={({ target }) => setSearch(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(search)}
					/>
				</SearchContainer>
				<Container>
					<ListAntiPassbacks filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormAntiPassbacks antiPassback={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaAntiPassbacks;
